export default __webpack_public_path__ + "static/media/contact-form (2).30892db5.png";